import React from 'react';
import { Modal, Form, Input, Button, Select, Checkbox, Space } from 'antd';
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { StatusNewsItem } from '../pages/AdminPage';

export type StatusNewsEditModalProps = {
  visible: boolean;
  loading: boolean;
  editingItem: StatusNewsItem | null;
  editForm: any;
  onSubmit: (values: Partial<StatusNewsItem>) => void;
  onCancel: () => void;
};

const StatusNewsEditModal: React.FC<StatusNewsEditModalProps> = ({
  visible,
  loading,
  editForm,
  onSubmit,
  onCancel,
}) => (
  <Modal
    title="Edit Status News Item"
    visible={visible}
    onCancel={onCancel}
    footer={null}
  >
    <Form form={editForm} layout="vertical" onFinish={onSubmit}>
      <Form.Item name="type" label="Type" rules={[{ required: true }]}>
        <Select>
          <Select.Option value="info" icon={<InfoCircleOutlined />}>
            Info
          </Select.Option>
          <Select.Option value="success" icon={<CheckCircleOutlined />}>
            Success
          </Select.Option>
          <Select.Option value="error" icon={<CloseCircleOutlined />}>
            Error
          </Select.Option>
        </Select>
      </Form.Item>
      <Form.Item name="title" label="Title">
        <Input placeholder="Optional short title" maxLength={80} />
      </Form.Item>
      <Form.Item name="text" label="Text">
        <Input.TextArea
          placeholder="Status message"
          maxLength={220}
          rows={3}
          showCount
        />
      </Form.Item>
      <Form.Item name="enabled" valuePropName="checked">
        <Checkbox>Enabled (show on banner)</Checkbox>
      </Form.Item>
      <Form.Item name="leftAlign" valuePropName="checked">
        <Checkbox>Left Align</Checkbox>
      </Form.Item>
      <Form.Item
        name="priority"
        label="Priority (if more, list after priority)"
        rules={[{ required: true }]}
      >
        <Input type="number" min={1} max={10} style={{ width: 120 }} />
      </Form.Item>
      <Form.Item name="linkText" label="Link Text">
        <Input placeholder="Optional link text" maxLength={40} />
      </Form.Item>
      <Form.Item name="linkUrl" label="Link URL">
        <Input placeholder="Optional link URL" maxLength={120} />
      </Form.Item>
      <Form.Item>
        <Space>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Space>
      </Form.Item>
    </Form>
  </Modal>
);

export default StatusNewsEditModal;
